import { z } from 'zod';

/** Server error codes (BACKEND.md §6.3). */
export const SERVER_ERROR_CODES = [
  'VALIDATION_FAILED',
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'CHALLENGE_LOCKED',
  'NOT_FOUND',
  'CONTENT_OUTDATED',
  'PAYLOAD_TOO_LARGE',
  'RATE_LIMITED',
  'INTERNAL',
] as const;

/** Every server code + the client-only `NETWORK` code (fetch failed, offline). */
export const API_ERROR_CODES = [...SERVER_ERROR_CODES, 'NETWORK'] as const;

export const ServerErrorCodeSchema = z.enum(SERVER_ERROR_CODES);
export type ServerErrorCode = z.infer<typeof ServerErrorCodeSchema>;

export const ApiErrorCodeSchema = z.enum(API_ERROR_CODES);
export type ApiErrorCode = z.infer<typeof ApiErrorCodeSchema>;

export const ErrorEnvelopeSchema = z.object({
  error: z.object({
    code: ServerErrorCodeSchema,
    message: z.string(),
    fields: z.record(z.string(), z.string()).optional(),
    details: z.record(z.string(), z.string()).optional(),
    requestId: z.string().optional(),
  }),
});
export type ErrorEnvelope = z.infer<typeof ErrorEnvelopeSchema>;

/** `?error=` values on `/auth/callback` (BACKEND.md §8). */
export const AUTH_CALLBACK_ERRORS = [
  'state_mismatch',
  'oauth_denied',
  'email_unverified',
  'link_invalid',
  'link_expired',
  'link_used',
] as const;
export type AuthCallbackError = (typeof AUTH_CALLBACK_ERRORS)[number];
